export { default as Bag } from './images/Bag.png';
export { default as KeepaTypeFa } from './images/KeepaTypeFa.svg';
export { default as KeepaLogoFa } from './images/KeepaLogoFa.svg';
export { default as FakeKeepaSliderPng } from './images/FakeSlider.png';
export { default as ImageShadowBig } from './images/imageShadowBig.svg';
export { default as ImageShadowMedium } from './images/imageShadowMedium.svg';
export { default as ImageShadowSmall } from './images/imageShadowSmall.svg';
export { default as WalletImg } from './images/Wallet-image.png';
export { default as LogoKeepa } from './images/logoKeepa.png';
export { default as KeepaLogoDeactiveSVG } from './images/KeepaLogoDeactive.svg';
export { default as Union } from './images/Union.png';
export { default as UsersSvg } from './images/Users.svg';
export { default as WebBarcodeSVG } from './images/Home_PWA.svg';
export { default as myketSVG } from './images/myketSVG.svg';
export { default as MyketBarcode } from './images/Home_myket.svg';
export { default as bazaarSVG } from './images/bazaarSVG.svg';
export { default as BazaarBarcode } from './images/Home_Bazaar.svg';
export { default as SaleCouponSvg } from './images/SaleCouponSvg.svg';
export { default as UnionSvg } from './images/UnionSvg.svg';
export { default as shapSvg } from './images/shap1.svg';
export { default as StarSvg } from './images/Star.svg';
export { default as CreditCardPng } from './images/CreditCard.png';
export { default as WebSvg } from './images/Web.svg';
export { default as IOSSvg } from './images/IOS.svg';
export { default as IOSBarcode } from './images/Home_PWA.svg';
export { default as LogotypeFaSvg } from './images/LogotypeFa.svg';
export { default as SaleIcon } from './images/Sale.png';
export { default as UserBold } from './images/user-bold.png';
export { default as After } from './images/after.png';
export { default as KeepaTypeFaBluePng } from './images/KeepaTypeFaBlue.svg';
export { default as ShapeIntoSvg } from './images/ShapeInto.svg';
export { default as Basket } from './images/basket.png';
export { default as BtnUp } from './images/bottomUp.png';
export { default as MenswearPng } from './images/Menswear.png';
export { default as MiniMenswearPng } from './images/MiniMenswear.png';
export { default as DoctorPng } from './images/Doctor.png';
export { default as DoctorToolsPng } from './images/DoctorTools.png';
export { default as SafarDotCom } from './images/safarDotCom.png';
export { default as IranFlag } from './images/iran-flag-flag.png';
export { default as BackgroundWalletKeepa } from './images/backgrpondWallet.png';
export { default as backgroundWalletMehr } from './images/backgroundWalletMehr.png';
export { default as SamandehiSvg } from './images/samandehi.svg';
export { default as ShaparakJpg } from './images/shaparak.jpg';
export { default as DaneshJpg } from './images/danesh.jpg';
export { default as DevooPNG } from './images/Devoo.png';
export { default as BimePNG } from './images/Landing/bimehPng.png';
export { default as EsnovaSvg } from './images/Esnova.svg';
export { default as HomeSamSvg } from './images/HomeSam.svg';
export { default as LunatoSvg } from './images/Lunato.svg';
export { default as ShimeSvg } from './images/Shime.svg';
export { default as JanbooSvg } from './images/Janboo.svg';
export { default as MenuFilter } from './images/MenuFilter.png';
export { default as backgroundWalletBNPL } from './images/backgroundWalletBNPL.png';
export { default as NotData } from './images/notFound.png';
export { default as Megaphone } from './images/Megaphone.png';
export { default as PlaceholderImage } from './images/placeholderImage.svg';
export { default as IconPlay } from './images/iconPlay.png';
export { default as AnjomanSvg } from './images/Anjoman.svg';
export { default as IranLogoSvg } from './images/IranLogo.svg';
export { default as licenseWorkSvg } from './images/licenseWork.svg';
export { default as LicensePng } from './images/license.png';
export { default as KeepaLogoWhite } from './images/KeepaLogoWhite.svg';
export { default as KeepaLogoRight } from './images/KeepaNewLogoRight.svg';
export { default as KeepaWhiteLogoRight } from './images/KeepaWhiteLogoRight.svg';
export { default as KeepaLogoLeft } from './images/KeepaNewLogoLeft.svg';
export { default as KeepaLogoBlue } from './images/KeepaLogoBlue.svg';
export { default as samtaJpg } from './images/samta.jpg';
export { default as sazmanNsrJpg } from './images/sazmanNsr.jpg';
export { default as sfaiJpg } from './images/sfai.jpg';
export { default as shaaJpg } from './images/shaa.jpg';
export { default as apiJpg } from './images/api.jpg';
export { default as smdhiJpg } from './images/smdhi.jpg';
export { default as naiJpg } from './images/nai.jpg';
export { default as locationKeepa } from './images/locationKeepa.jpg';
export { default as Iphone14pro } from './images/Iphone14pro.png';
export { default as Star1 } from './images/star1.png';
export { default as Star2 } from './images/star2.png';
export { default as PosterVideoWallet } from './images/posterVideoWallet.png';
export { default as TestImg } from './images/testImg.png';
export { default as Step1 } from './images/WalletGuide/1.png';
export { default as Step2 } from './images/WalletGuide/2.png';
export { default as Step3 } from './images/WalletGuide/3.png';
export { default as Step4 } from './images/WalletGuide/4.png';
export { default as Step5 } from './images/WalletGuide/5.png';
export { default as Step6 } from './images/WalletGuide/6.png';
export { default as Step7 } from './images/WalletGuide/7.png';
export { default as Step8 } from './images/WalletGuide/8.png';
export { default as Step9 } from './images/WalletGuide/9.png';
export { default as Step10 } from './images/WalletGuide/10.png';
export { default as Step11 } from './images/WalletGuide/11.png';
export { default as Step12 } from './images/WalletGuide/12.png';
export { default as S1 } from './images/PurchaseGuide/online/1.png';
export { default as S2 } from './images/PurchaseGuide/online/2.png';
export { default as S3 } from './images/PurchaseGuide/online/3.png';
export { default as S4 } from './images/PurchaseGuide/online/4.png';
export { default as S5 } from './images/PurchaseGuide/online/5.png';
export { default as S6 } from './images/PurchaseGuide/online/6.png';
export { default as S9 } from './images/PurchaseGuide/person/9.png';
export { default as S10 } from './images/PurchaseGuide/person/10.png';
export { default as S12 } from './images/PurchaseGuide/person/12.png';
export { default as S13 } from './images/PurchaseGuide/person/13.png';
export { default as S14 } from './images/PurchaseGuide/person/14.png';
export { default as Iran_AmozeshoParvaresh } from './images/Iran_AmozeshoParvaresh.png';
export { default as OrganizationHeader } from './images/organizationHeader.png';
export { default as Day } from './images/Organazation/bank dey.png';
export { default as IranMimt } from './images/Organazation/vezarat sanat.png';
export { default as Irancell } from './images/Organazation/irancell.png';
export { default as Mehr } from './images/Organazation/bank mehr.png';
export { default as Pasargad } from './images/Organazation/pasargad.png';
export { default as RefahBank } from './images/Organazation/refah.png';
export { default as Refahiranin } from './images/Organazation/fari.png';
export { default as Rightel } from './images/Organazation/rightel.png';
export { default as Saman } from './images/Organazation/saman.png';
export { default as Sepah } from './images/Organazation/sepah.png';
export { default as Tamin } from './images/Organazation/tamin.png';
export { default as FoladMobarke } from './images/Organazation/folad.png';
export { default as MerchantPage } from './images/MerchantPage.png';
export { default as User1 } from './images/Merchant/User/1.png';
export { default as User2 } from './images/Merchant/User/2.png';
export { default as User3 } from './images/Merchant/User/3.png';
export { default as User4 } from './images/Merchant/User/4.png';
export { default as User5 } from './images/Merchant/User/5.png';
export { default as User6 } from './images/Merchant/User/6.png';
export { default as KhaneFarsh } from './images/Merchant/business/khane_farsh.png';
export { default as KhaneFarshManager } from './images/Merchant/business/khane_farsh_manager.png';
export { default as BimeTaavoun } from './images/Merchant/business/bime_taavoun.png';
export { default as BimeTaavounManager } from './images/Merchant/business/taavoun_manager.png';
export { default as Bime } from './images/Merchant/business/bime.png';
export { default as BimeManager } from './images/Merchant/business/bime_manager.png';
export { default as Safar } from './images/Merchant/business/safar.png';
export { default as SafarManager } from './images/Merchant/business/safar_manager.png';
export { default as SnappExpress } from './images/Merchant/business/snapp_express.png';
export { default as SnappExpressManager } from './images/Merchant/business/snapp_express_manager.png';
export { default as ShadowGroupSVG } from './images/Merchant/shadowGroup.svg';
export { default as ContractForm } from './images/Merchant/ContractForm.png';
export { default as UnionBeforeSvg } from './images/UnionBeforeSvg.svg';
export { default as finalSazman } from './images/final-sazman-image.png';
export { default as Vector } from './images/Vector.png';
export { default as LowBtn } from './images/LowBtn.png';
export { default as PlusBtn } from './images/plusBtn.png';
export { default as PosterVideo } from './images/posterVideo.png';
export { default as LogoOrganazation } from './images/LogoOrganazation.png';
export { default as LogoBNPL } from './images/LogoBNPL.png';
export { default as Linkdin } from './images/linkedin.png';
export { default as janboPng } from './images/Landing/Canbo.png';
export { default as familyPng } from './images/Landing/Family.png';
export { default as DailyMarketPng } from './images/Landing/DailyMarket.png';
export { default as sevenPng } from './images/Landing/Seven.png';
export { default as BasketPng } from './images/Landing/Basket.png';
export { default as CallSVG } from './images/Landing/Call.svg';
export { default as LogoKeepaFa } from './images/Landing/Keepa Logo Fa.svg';
export { default as KeepaStar } from './images/Landing/KeepaStar.png';
export { default as TeacherPng } from './images/Landing/Teacher.png';
export { default as VideoPng } from './images/Landing/Video.png';
export { default as VideoFaraPng } from './images/Landing/VideoFara.png';
export { default as EtmaPng } from './images/Landing/Etma.png';
export { default as instalmentPeriod } from './images/Landing/instalmentPeriod.svg';
export { default as CoinPng } from './images/Landing/coin.png';
export { default as Coin1Png } from './images/Landing/entekhab/coin.png';
export { default as CalenderPng } from './images/Landing/entekhab/calendar.png';
export { default as MobileWalletPng } from './images/Landing/1.png';
export { default as BasketWalletPng } from './images/Landing/2.png';
export { default as LetterWalletPng } from './images/Landing/3.png';
export { default as PostWalletPng } from './images/Landing/4.png';
export { default as CircleListSVG } from './images/Landing/circleList.svg';
export { default as OnlineShoppingPNG } from './images/Landing/online-shopping.png';
export { default as WebBrowserPNG } from './images/Landing/web-browser.png';
export { default as About1 } from './images/About/about1.png';
export { default as About2 } from './images/About/About2.png';
export { default as About3 } from './images/About/About3.jpg';
export { default as About4 } from './images/About/About4.png';
export { default as StoreAbout } from './images/About/store.png';
export { default as Gallery1 } from './images/About/Gallery/gallery1.jpg';
export { default as Gallery2 } from './images/About/Gallery/gallery2.jpg';
export { default as Gallery3 } from './images/About/Gallery/gallery3.jpg';
export { default as Gallery4 } from './images/About/Gallery/gallery4.jpg';
export { default as Gallery5 } from './images/About/Gallery/gallery5.jpg';
export { default as Gallery6 } from './images/About/Gallery/gallery6.jpg';
export { default as Gallery7 } from './images/About/Gallery/gallery7.jpg';
export { default as Gallery8 } from './images/About/Gallery/gallery8.jpg';
export { default as Gallery9 } from './images/About/Gallery/gallery9.jpg';
export { default as Sazman1 } from './images/About/Sazman/Sazman1.png';
export { default as Sazman2 } from './images/About/Sazman/Sazman2.png';
export { default as Sazman3 } from './images/About/Sazman/Sazman3.png';
export { default as Sazman4 } from './images/About/Sazman/Sazman4.png';
export { default as Sazman5 } from './images/About/Sazman/Sazman5.png';
export { default as Sazman6 } from './images/About/Sazman/Sazman6.png';
export { default as Sazman7 } from './images/About/Sazman/Sazman7.png';
export { default as Sazman8 } from './images/About/Sazman/Sazman8.png';
export { default as Sazman9 } from './images/About/Sazman/Sazman9.png';
export { default as Store1 } from './images/About/Store/Store1.png';
export { default as Store2 } from './images/About/Store/Store2.png';
export { default as Store3 } from './images/About/Store/Store3.png';
export { default as Store4 } from './images/About/Store/Store4.png';
export { default as Store5 } from './images/About/Store/Store5.png';
export { default as Store6 } from './images/About/Store/Store6.png';
export { default as Store7 } from './images/About/Store/Store7.png';
export { default as Store8 } from './images/About/Store/Store8.png';
export { default as Store9 } from './images/About/Store/Store9.png';
export { default as Store10 } from './images/About/Store/Store10.png';
export { default as AboutMobile } from './images/About/AboutMobile.png';
export { default as Blockquote } from './images/blockquote.svg';
export { default as WhaleMarketPNG } from './images/Landing/WhaleMarket.png';
export { default as BannerMobile } from './images/Banner/bannerMobile.jpg';
export { default as BannerDesktop } from './images/Banner/bannerDesktop.jpg';
export { default as MehrLogoPng } from './images/Organazation/mehrLogo.png';
export { default as SnowGroup } from './images/Landing/snowa/groupbySnow.png';
export { default as EntekhabPng } from './images/Landing/snowa/entekhab.png';
export { default as EntekhabBluePng } from './images/Landing/snowa/entekhabBlue.png';
export { default as image1Png } from './images/Landing/snowa/image1.png';
export { default as image2Png } from './images/Landing/snowa/image2.png';
export { default as image3Png } from './images/Landing/snowa/image3.png';
export { default as image4Png } from './images/Landing/snowa/image4.png';
export { default as image5Png } from './images/Landing/snowa/image5.png';
export { default as image6Png } from './images/Landing/snowa/image6.png';
export { default as Tejart } from './images/Landing/snowa/tejart.png';
export { default as Header } from './images/Landing/snowa/header.png';
export { default as BackgroundCircle } from './images/Landing/snowa/Avatar.png';
export { default as StarSilver } from './images/Landing/snowa/starSilver.png';
export { default as StarGold } from './images/Landing/snowa/starGold.png';
export { default as HeaderMobile } from './images/Landing/snowa/headerMobile.png';
export { default as EnteKahb } from './images/Landing/entekhab/EnteKahb.png';
export { default as MobileEntekhab } from './images/Landing/entekhab/MobileEntekhab.png';
export { default as EntekhabinoLogo } from './images/Landing/entekhab/EntekhabinoLogo.png';
export { default as CopyRightSVG } from './images/Landing/entekhab/copyright.svg';
export { default as SixDots } from './images/Landing/6Dots.png';
export { default as KeepaLogoFaNew } from './images/logo/KeepaLogoFa.png';
export { default as Bazar } from './images/iconShareLink/bazar.png';
export { default as ShareIcon } from './images/iconShareLink/share.png';
export { default as AppStore } from './images/iconShareLink/appStore.png';
export { default as HouseholdAppliancesSVG } from './images/Landing/HouseholdAppliances/coverImage.png';
export { default as tapeSVG } from './images/Landing/HouseholdAppliances/tape.png';
export { default as BekanTonPNG } from './images/Landing/HouseholdAppliances/BekanTon.png';
export { default as FarshPNG } from './images/Landing/HouseholdAppliances/Farsh.png';
export { default as GoldIranPNG } from './images/Landing/HouseholdAppliances/GoldIran.png';
export { default as ShahrLavazemPNG } from './images/Landing/HouseholdAppliances/ShahrLavazem.png';
export { default as MahdPNG } from './images/Landing/HouseholdAppliances/Mahd.png';
export { default as MadiranPNG } from './images/Landing/HouseholdAppliances/Madiran.png';
export { default as Slider1PNG } from './images/Landing/HouseholdAppliances/swiper_slide_1_home.jpg';
export { default as FaraLogoSVG } from './images/Landing/fara/TaminLogo.svg';
export { default as FaraHereSectionDesktopPNG } from './images/Landing/fara/hereSectionDesktop.png';
export { default as FaraHereSectionMobilePNG } from './images/Landing/fara/hereSectionMobile.png';
export { default as FaraCallPNG } from './images/Landing/fara/CallPng.png';
export { default as instalmentPeriodFaraSVG } from './images/Landing/fara/instalmentPeriodFara.svg';
